
<script>

    export let view_modal;
    export let active_data;
    import { afterUpdate } from 'svelte';
    let photo_link;

    //Create Photo link here as well
    //https://raw.githubusercontent.com/HudsonRiverFoundation/RAM-Data/main/Photos/ChristianMurphyBronxRiverAlliance-ChristianMurphy.jpg
    if (active_data) {
        active_data = active_data[0].properties;
        photo_link = `https://raw.githubusercontent.com/HudsonRiverFoundation/RAM-Data/main/Photos/${active_data.Photo}.jpg`        
    }

    function closeX() {
        view_modal = !view_modal;
    }

    function modalClick(e) {
        //If image or x is cliked don't do anything.
        if( e.target.className.includes("close-x") || e.target.className.includes("modal-Photo") ){
            console.log("x or image clicked")
        }else{
            view_modal = !view_modal;
            console.log(view_modal)
        }
    }
    
    afterUpdate(() => {
        if (view_modal){
            [...document.getElementsByClassName("modal")][0].className = "modal modal-view"   
        }else{
            [...document.getElementsByClassName("modal")][0].className = "modal modal-hide" 
        }
    });

</script>

<div on:click={modalClick} class="modal modal-hide">
    {#if view_modal}
        <div class="modal-image">
            <div class="close-x" on:click={closeX}>&#10006;</div>
            <img class="modal-Photo" alt={active_data.SiteName} src={photo_link} />
        </div>
    {/if}
</div>

<style>
    .close-x{
        color: var(--blue);
        float:right;
        cursor: pointer;
        font-size: 1.5rem;
        font-weight: bold;
        transform: translate(-0.5rem,2.2rem);
    }

    .modal-image {
        width: 500px;
        height: 500px;
        margin: auto;
    }

    img{
        max-width: 100%;
        max-height: 100%;
    }


</style>

